import { render, staticRenderFns } from "./SectionBlock.vue?vue&type=template&id=4aea16ce&scoped=true"
import script from "./SectionBlock.vue?vue&type=script&lang=js"
export * from "./SectionBlock.vue?vue&type=script&lang=js"
import style0 from "./SectionBlock.vue?vue&type=style&index=0&id=4aea16ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea16ce",
  null
  
)

export default component.exports